export const NOMIN_REVERSE = 'https://nominatim.openstreetmap.org/reverse';
export const NOMIN_SEARCH = 'https://nominatim.openstreetmap.org/search';

export const OPENCAGE = 'https://api.opencagedata.com/geocode/v1/json';
